import * as uni from '@/assets/webview.js';
export var appMethod = {
  data: function data() {
    return {
      handleQuery: true
    };
  },
  created: function created() {
    if (this.handleQuery) {
      this.$store.commit('SET_TOKEN', this.$route.query.token);
      this.$route.query.headerParam ? this.$store.commit('SET_REQUEST_HEADER_PARAM', JSON.parse(this.$route.query.headerParam)) : '';
    }
  },
  methods: {
    navigateTo: function navigateTo(url) {
      uni.getEnv(function (res) {
        console.log('res', res);

        if (res.miniprogram) {
          wx.miniProgram.navigateTo({
            url: url
          });
        } else {
          uni.navigateTo({
            url: url
          });
        }
      });
    }
  }
};